import CityPageTemplate from "../city-template/CityPageTemplate";
import { minotConfig } from "./data";

export default function MinotPage() {
  return <CityPageTemplate config={minotConfig} />;
}